module.exports = "<ng-template #popTemplate>\n   <!--div [innerHtml]=\"html\"></div-->\n   <app-operation-info-view id=\"view\"></app-operation-info-view>\n</ng-template>\n<a class=\"opInfoBtn\" [popover]=\"popTemplate\" container=\"body\" placement=\"left\" adaptivePosition=\"true\" outsideClick=\"true\" (onShown)=\"loadOperationInfo()\">\n{{this.status}}\n</a>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/achelos-iot/operation-info/operation-info.component.html
// module id = ./src/app/achelos-iot/operation-info/operation-info.component.html
// module chunks = main